import { ChangeDetectionStrategy, Component } from '@angular/core';
import { Router } from '@angular/router';
import { APP_ROUTE } from 'app/app-routing.constant';
import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({
    selector: 'kh-demo-message-modal',
    templateUrl: './demo-message-modal.component.html',
    styleUrls: ['./demo-message-modal.component.less'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class DemoMessageModalComponent {

  constructor(
    private readonly router: Router,
    private readonly bsModalRef: BsModalRef,) {
  }

  public addClass(): void {
    const route = APP_ROUTE.TEACHERS.CLASS_MANAGEMENT.route();
    this.router.navigate(route, {queryParams: {addClass: true}})
    this.bsModalRef.hide();
  }

  public close(): void {
    this.bsModalRef.hide();
  };
}
